import createIcon from '../../createIcon';

/**
 * @component @name KeyboardArrowRight
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOC4yOTQ5MiAxNi41OUwxMi44NzQ5IDEyTDguMjk0OTIgNy40MUw5LjcwNDkyIDZMMTUuNzA0OSAxMkw5LjcwNDkyIDE4TDguMjk0OTIgMTYuNTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const KeyboardArrowRight = createIcon('KeyboardArrowRight', [
  [
    'path',
    {
      d: 'M8.29492 16.59L12.8749 12L8.29492 7.41L9.70492 6L15.7049 12L9.70492 18L8.29492 16.59Z',
      key: '9bplzx',
    },
  ],
]);

export default KeyboardArrowRight;
